<div [class]="'hx-checkbox-group ' + className()">
  @for (option of options(); track option.value) {
    <label [class]="'hx-checkbox-wrapper ' + className() + (disabled() ? ' disabled' : '')">
      <div class="hx-checkbox-container">
        <input
          #input
          class="hx-checkbox-input"
          type="checkbox"
          [checked]="_isOptionSelected(option.value)"
          [hxIndeterminate]="option.indeterminate ?? false"
          [disabled]="disabled()"
          [value]="option.value"
          (keydown)="_handleInputKeydown(option.value, $event)"
          (change)="_handleOptionChange(option.value, $event)" />
        <span class="hx-checkbox-box"></span>
      </div>
      <span class="hx-checkbox-label">{{ option.label }}</span>
    </label>
  }
</div>
